















import Vue, { PropOptions } from 'vue';

export type ColumnItemIcon = Blok & {
  icon: BlokFieldAsset;
  soonBadge: boolean;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<ColumnItemIcon>,
  },
});
